/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CumulativeSessionCost } from "./CumulativeSessionCost";
import {
    CumulativeSessionCostFromJSON,
    CumulativeSessionCostFromJSONTyped,
    CumulativeSessionCostToJSON,
} from "./CumulativeSessionCost";

/**
 *
 * @export
 * @interface CumulativeSessionCostResponse
 */
export interface CumulativeSessionCostResponse {
    /**
     *
     * @type {Array<CumulativeSessionCost>}
     * @memberof CumulativeSessionCostResponse
     */
    items?: Array<CumulativeSessionCost>;
    /**
     * Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings
     * @type {string}
     * @memberof CumulativeSessionCostResponse
     */
    siteTimeZone?: string;
}

/**
 * Check if a given object implements the CumulativeSessionCostResponse interface.
 */
export function instanceOfCumulativeSessionCostResponse(
    value: object,
): value is CumulativeSessionCostResponse {
    return true;
}

export function CumulativeSessionCostResponseFromJSON(
    json: any,
): CumulativeSessionCostResponse {
    return CumulativeSessionCostResponseFromJSONTyped(json, false);
}

export function CumulativeSessionCostResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CumulativeSessionCostResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(
                      CumulativeSessionCostFromJSON,
                  ),
        siteTimeZone:
            json["siteTimeZone"] == null ? undefined : json["siteTimeZone"],
    };
}

export function CumulativeSessionCostResponseToJSON(
    value?: CumulativeSessionCostResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(
                      CumulativeSessionCostToJSON,
                  ),
        siteTimeZone: value["siteTimeZone"],
    };
}
